/* DON'T EDIT THIS FILE: edit original and run build again */ export const onEnterToOnKeyPress =
  <TElement>(onEnter: (event: React.KeyboardEvent<TElement>) => void) =>
  (event: React.KeyboardEvent<TElement>) => {
    if (event.key === "Enter") {
      onEnter(event);
    }
  };
